<template>
  <div class="text-center">
    <v-dialog v-model="dialog" max-width="500" persistent>
      <template v-slot:activator="{ on, attrs }">
        <Tooltip
          v-on="on"
          v-bind="attrs"
          id="delete"
          :type="isMobile ? 'icon' : 'button'"
          icon="delete"
          :tooltipText="$t('shooting.buttons.deleteVideo')"
          :tooltipButtonText="$t('shooting.buttons.deleteVideo')"
          v-on:tooltipdelete="tooltipEmit"
        />
      </template>

      <v-card :loading="loading" :disabled="loading">
        <v-card-title class="headline grey lighten-2">{{ $t('shooting.deleteVideo.title') }}</v-card-title>

        <v-card-text class="pa-7 text--primary">
          {{ $t('shooting.deleteVideo.textPrimary') }}
        </v-card-text>

        <v-card-text class="px-7">
          {{ $t('shooting.deleteVideo.textSecondary') }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="dialog = false"> {{ $t('common.cancel') }} </v-btn>
          <v-btn color="error" text @click="deleteVideo"> {{ $t('common.delete') }} </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Tooltip from '@/components/common/atoms/Tooltip'

export default {
  name: 'DeleteVideo',

  components: {
    Tooltip
  },

  data() {
    return {
      dialog: false,
      loading: false
    }
  },

  methods: {
    tooltipEmit() {
      this.dialog = true
    },

    async deleteVideo() {
      this.loading = true

      const res = await this.$store.dispatch('deleteVideo', {
        ownerId: this.$route.params.ownerId,
        productId: this.$route.params.productId,
        shootingId: this.$route.params.shootingId
      })

      res && this.$router.push('/shootings')

      this.loading = false
    }
  },

  computed: {
    isMobile() {
      const width = window.innerWidth > 0 ? window.innerWidth : screen.width
      return width < 750
    }
  }
}
</script>

<style lang="sass" scoped></style>
